import { v4 as uuidV4 } from "uuid";
import React, { useContext, useMemo } from "react";

export interface JupiterEventContextInterface {
  eventId: string;
}

export interface JupiterEventProviderProps {
  children: (eventId: string) => React.ReactElement | null;
}

export const JupiterEventContext = React.createContext<JupiterEventContextInterface>({ eventId: "" });

export const JupiterEventProvider: React.VFC<JupiterEventProviderProps> = ({ children }) => {
  const eventId = useMemo(() => uuidV4(), []);

  return (
    <JupiterEventContext.Provider value={{ eventId }}>
      {children(eventId)}
    </JupiterEventContext.Provider>
  );
};

export const useJupiterEventId = () => {
  const ctx = useContext(JupiterEventContext);
  return ctx.eventId;
};
